import { LinearProgress } from '@material-ui/core';
import { ReactKeycloakProvider as ReactProvider } from '@visma/react-keycloak';
import { axios } from 'api';
import getKeycloak from './getKeycloak';
import ProviderMock from './ProviderMock';

export const Provider = process.env.REACT_APP_KEYCLOAK_MOCK_USER
  ? ProviderMock
  : ReactProvider;

export default function ReactKeycloakProvider(props) {
  return (
    <Provider
      axios={axios}
      authClient={getKeycloak()}
      LoadingComponent={<LinearProgress />}
      {...props}
    />
  );
}
